@if(showSearch) {
    <div class="filter-height">
        <div class="d-flex justify-between p-r-20 p-l-20 m-t-20 m-b-15">
            <h2 class="font-15 title-filter  p-r-20 filter">
                <fa-icon (click)="showSearch = false" id="back-panel-search" class="font-16 m-r-10"
                    [icon]="['fas', 'arrow-left']"></fa-icon>{{
                ( currentSearchPanel === 'annualSummaryYears'
                ? ('home-page.summary.configuration-modal-summary-title' | translate)
                : ('home-page.summary.configuration-modal-fee-title' | translate) ) }}
            </h2>
        </div>
        <div class="d-flex flex-row ">
            <mat-form-field class="input-regular p-r-20 p-l-20" appearance="outline" style="flex: 1;">
                <input matInput type="text" id="annualYears" placeholder="Buscar" [formControl]="panelSearchControl">
                <fa-icon class="p-absolute font-14 negative-r-5" [icon]="['fal', 'times']" (click)="clearInputSearch()"
                    [hidden]="!panelSearchControl.value">
                </fa-icon>
            </mat-form-field>
        </div>

        @switch(currentSearchPanel) {

            @case ('annualFeeYears') {
                <div class="d-flex flex-column p-l-20 p-r-20" (click)="sortAnualFeeYears()">
                    @for( feeYear of searchAnnualFeeYears; track feeYear; let idx = $index ){
                    <div class="m-t-5 m-b-5">
                        <mat-checkbox [color]="'primary'" [id]="feeYear"
                        [checked]="isChecked(feeYear, 'annualFeeYears')"
                        (change)="updateChkbxArray($event, feeYear, 'annualFeeYears')">
                            <span class="accordion-item m-l-5">
                                {{ feeYear }}

                                @if(feeYear === currentYear.toString()) {
                                <span class="accordion-item-current-year">
                                    - {{ 'home-page.summary.current-year-label' | translate }}
                                </span>
                                }
                            </span>
                        </mat-checkbox>
                    </div>

                    }

                </div>
            }

            @case ('annualSummaryYears') {
                <div class="d-flex flex-column p-l-20 p-r-20" (click)="sortAnualSummaryYears()">
                    @for( summaryYear of searchAnnualSummaryYears; track summaryYear; let idx = $index ){
                    <div class="m-t-5 m-b-5">
                        <mat-checkbox [color]="'primary'" [id]="summaryYear"
                        [checked]="isChecked(summaryYear, 'annualSummaryYears')"
                        (change)="updateChkbxArray($event, summaryYear, 'annualSummaryYears')">
                            <span class="accordion-item m-l-5">
                                {{ summaryYear }}

                                @if(summaryYear === currentYear.toString()) {
                                <span class="accordion-item-current-year">
                                    - {{ 'home-page.summary.current-year-label' | translate }}
                                </span>
                                }
                            </span>
                        </mat-checkbox>
                    </div>

                    }

                </div>
            }
        }

        @if (panelSearchControl.errors) {
        <div class="m-t-16 p-l-20 p-r-20">
            <span class="mat-body-1 message-not-found">{{ panelSearchControl.errors?.['notFound'] | translate }}</span>
        </div>
        }

    </div>

    <div>
        <div class="p-l-20 p-r-20 p-t-20 p-b-20">
            <button mat-raised-button color="primary" type="submit" class="w-per-100"
                id="btn-submit" (click)="applySearch()">
                {{ 'remuneration-page.filter.accept' | translate }}
            </button>
        </div>
    </div>

} @else {

<div class="configurations-dialog">
    <div class="configurations-dialog-wrapper">
        <div class="">
            <div class="d-flex justify-between p-r-20 p-l-20 m-t-20 m-b-15">
                <h2 class="font-15 title-filter  p-r-20 filter">
                    <fa-icon id="back-home" class="font-16 m-r-10" [icon]="['fas', 'arrow-left']"
                    (click)="close()">
                    </fa-icon>

                    {{ 'home-page.summary.configuration-modal-main-title' | translate }}

                </h2>

            </div>

            <div>
                <mat-accordion multi>
                    <mat-expansion-panel #panelFee>
                        <mat-expansion-panel-header (click)="sortAnualFeeYears()">
                            <div class="accordion-container">
                                <mat-panel-title>
                                    {{ 'home-page.summary.configuration-modal-fee-label' | translate }}
                                </mat-panel-title>
                                <div class="accordion-item-selected">
                                    {{ getName('annualFeeYears') }}
                                </div>
                            </div>
                            <fa-icon [icon]="['fal','angle-down']" [rotate]="panelFeeOpen ? 180 : undefined"
                            class="font-16 m-t-3"></fa-icon>

                        </mat-expansion-panel-header>
                        <div class="p-l-8 p-r-20">
                            @for( feeYear of annualFeeYears; track feeYear; let idx = $index ){

                            @if( idx < annualFeeYearsCurrentIndex * 6) { <div class="m-t-5 m-b-5">
                                <mat-checkbox [color]="'primary'" [id]="feeYear"
                                    [checked]="isChecked(feeYear, 'annualFeeYears')"
                                    (change)="updateChkbxArray($event, feeYear, 'annualFeeYears')">
                                    <span class="accordion-item m-l-5">
                                        {{ feeYear }}

                                        @if(feeYear === currentYear.toString()) {
                                        <span class="accordion-item-current-year">
                                            - {{ 'home-page.summary.current-year-label' | translate }}
                                        </span>
                                        }
                                    </span>
                                </mat-checkbox>

                        </div>
                        }
                        }
            </div>
            <div class="d-flex flex-row justify-start">
                @if(annualFeeYearsCurrentIndex < (annualFeeYears.length / 6)){ <p [id]="'viewMore-annualFeeYears'"
                    (click)="viewMore( 'annualFeeYears' )"
                    class="text-decoration-underline d-flex align-item-center p-l-10 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                    <fa-icon class="font-16  m-r-5" [icon]="['fal', 'angle-down']"></fa-icon>
                    {{'common-page.paginator.see-more' | translate }}
                    </p>
                    }
                    @if(annualFeeYearsCurrentIndex > 1) {
                    <p [id]="'viewLess-annualFeeYears'" (click)="viewLess( 'annualFeeYears' )"
                        class="text-decoration-underline d-flex align-item-center p-l-10 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                        <fa-icon class="font-16  m-r-5" [icon]="['fal', 'angle-up']"></fa-icon>
                        {{ 'common-page.paginator.see-less' | translate }}
                    </p>
                    }
                    <p [id]="'panel-search-annualFeeYears'" (click)="search('annualFeeYears')"
                        class="text-decoration-underline d-flex align-item-center p-l-20 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                        <fa-icon class="font-16  m-r-5" [icon]="['fal', 'search']" [fixedWidth]="false"></fa-icon>
                        {{'remuneration-page.filter.search' | translate }}
                    </p>

            </div>

            </mat-expansion-panel>

            <mat-expansion-panel #panelSummary>
                <mat-expansion-panel-header (click)="sortAnualSummaryYears()">
                    <div class="accordion-container">
                        <mat-panel-title>
                            {{ 'home-page.summary.configuration-modal-summary-label' | translate }}
                        </mat-panel-title>
                        <div class="accordion-item-selected">
                            {{ getName('annualSummaryYears') }}
                        </div>
                    </div>

                    <fa-icon [icon]="['fal','angle-down']" [rotate]="panelSummaryOpen ? 180 : undefined"
                    class="font-16 m-t-3"></fa-icon>
                </mat-expansion-panel-header>
                <div style="padding-left: 14px !important;">
                    @for( summaryYear of annualSummaryYears; track summaryYear; let idx = $index ){

                    @if( idx < annualSummaryYearsCurrentIndex * 6) { <div class="m-t-5 m-b-5">
                        <mat-checkbox [color]="'primary'" [id]="summaryYear"
                        [checked]="isChecked(summaryYear, 'annualSummaryYears')"
                        (change)="updateChkbxArray($event, summaryYear, 'annualSummaryYears')">
                            <span class="accordion-item m-l-5">
                                {{ summaryYear }}

                                @if(summaryYear === currentYear.toString()) {
                                <span class="accordion-item-current-year">
                                    - {{ 'home-page.summary.current-year-label' | translate }}
                                </span>
                                }
                            </span>
                        </mat-checkbox>

                </div>
                }
                }

                <div class=" d-flex flex-row justify-start">
                    @if(annualSummaryYearsCurrentIndex < (annualFeeYears.length / 6)){ <p
                        [id]="'viewMore-annualSummaryYears'" (click)="viewMore( 'annualSummaryYears' )"
                        class="text-decoration-underline d-flex align-item-center p-l-10 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                        <fa-icon class="font-16  m-r-5" [icon]="['fal', 'angle-down']"></fa-icon>
                        {{'common-page.paginator.see-more' | translate }}
                        </p>
                        }
                        @if(annualSummaryYearsCurrentIndex > 1) {
                        <p [id]="'viewLess-annualSummaryYears'" (click)="viewLess( 'annualSummaryYears' )"
                            class="text-decoration-underline d-flex align-item-center p-l-10 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                            <fa-icon class="font-16  m-r-5" [icon]="['fal', 'angle-up']"></fa-icon>
                            {{ 'common-page.paginator.see-less' | translate }}
                        </p>
                        }
                        <p [id]="'panel-search-annualSummaryYears'" (click)="search( 'annualSummaryYears' )"
                            class="text-decoration-underline d-flex align-item-center p-l-20 p-t-10 p-b-20 m-b-0 p-r-20 justify-center">
                            <fa-icon class="font-16  m-r-5" [icon]="['fal', 'search']" [fixedWidth]="false"></fa-icon>
                            {{'remuneration-page.filter.search' | translate }}
                        </p>

                </div>
        </div>
        </mat-expansion-panel>

        </mat-accordion>
    </div>
</div>

<div class="configurations-dialog-wrapper-actions p-l-20 p-r-20 p-t-20 p-b-20">
    <button class="configurations-dialog-wrapper-actions-applied w-per-100" mat-raised-button color="primary" type="submit"
        id="btn-submit" (click)="submit()" [disabled]="!hasChange || !formControl.valid">
        {{ 'common-page.custom-dropdown.apply-button-label' | translate }}
    </button>
    <button class="configurations-dialog-wrapper-actions-cancel w-per-100 m-t-10 secondary" mat-raised-button type="submit"
        id="btn-cancel" (click)="close()">
        {{ 'common-page.custom-dropdown.cancel-button-label' | translate }}
    </button>
</div>
</div>

</div>
}
